var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { useAppSelector } from '../../store';
const speechServicesSelector = (state) => state.speechServices;
const SubtitleArea = () => {
    _react_refresh_temp_2();
    const speechServices = useAppSelector(speechServicesSelector);
    const [finalTexts, setFinalTexts] = useState({
        first: undefined,
        second: undefined,
    });
    const [subtitleText, setSubtitleText] = useState(undefined);
    useMemo(() => {
        if (speechServices.finalText) {
            setFinalTexts((prevState) => ({
                ...prevState,
                first: prevState.first,
                second: speechServices.finalText,
            }));
        }
    }, [speechServices.finalText]);
    useEffect(() => {
        var _a, _b, _c;
        if (!finalTexts.first && !finalTexts.second) {
            return;
        }
        let lastLineFrom = '';
        let text = [];
        if (finalTexts.first &&
            ((_a = finalTexts.first) === null || _a === void 0 ? void 0 : _a.from) === ((_b = finalTexts.second) === null || _b === void 0 ? void 0 : _b.from)) {
            // both are the same person
            const t = finalTexts.first.text + ' ' + ((_c = finalTexts.second) === null || _c === void 0 ? void 0 : _c.text);
            text.push(`${finalTexts.first.from}:`, t.slice(-50));
            lastLineFrom = finalTexts.first.from;
        }
        else {
            // they are both different person
            if (finalTexts.first) {
                text.push(`${finalTexts.first.from}:`, finalTexts.first.text.slice(-20));
                if (finalTexts.second) {
                    // if second data exist, then we'll require adding a new line
                    text.push('\n');
                }
                lastLineFrom = finalTexts.first.from;
            }
            if (finalTexts.second) {
                text.push(`${finalTexts.second.from}:`, finalTexts.second.text.slice(-50));
                lastLineFrom = finalTexts.second.from;
            }
        }
        if (speechServices.interimText) {
            if (speechServices.interimText.text.length > 100) {
                // if we have a lot of text then better to show only those
                text = [
                    `${speechServices.interimText.from}:`,
                    speechServices.interimText.text.slice(-200),
                ];
            }
            else {
                if (lastLineFrom === speechServices.interimText.from) {
                    text.push(speechServices.interimText.text);
                }
                else {
                    text.push('\n', `${speechServices.interimText.from}:`, speechServices.interimText.text);
                }
            }
        }
        if (!text.length) {
            return;
        }
        setSubtitleText(text.join(' '));
        const clear = setTimeout(() => {
            setSubtitleText(undefined);
        }, 10000);
        return () => {
            if (clear) {
                clearTimeout(clear);
            }
        };
    }, [finalTexts, speechServices.interimText]);
    return (_jsx(_Fragment, { children: speechServices.selectedSubtitleLang !== '' &&
            subtitleText !== undefined ? (_jsx("div", { className: "sub-title w-11/12 absolute bottom-4  left-1/2 -translate-x-1/2 pointer-events-none px-10 flex items-center", style: { fontSize: speechServices.subtitleFontSize }, children: _jsx("p", { className: "py-1 px-2 bg-black text-white m-auto inline-block break-words text-center whitespace-pre-wrap", children: subtitleText }) })) : null }));
};
_react_refresh_temp_1 = SubtitleArea;
$RefreshReg$(_react_refresh_temp_1, "SubtitleArea");
_react_refresh_temp_2(SubtitleArea, "KZ4vz6VqnYOhz/LNmrRN06Cty/c=", false, () => [useAppSelector]);
export default SubtitleArea;
